<template>
    <b-button
        class="center-element vk-button align-items-center mt-3 position-relative"
        :href="`${link}&usage=${usage}`"
        :style="buttonStyle"
    >

        <img src="../assets/images/socialIcons/vk.svg" class="social-icon" :style="iconStyle">
        <div class="d-flex align-items-center" :style="iconTextStyle">
            {{ buttonText }}
        </div>
    </b-button>
</template>

<script>
    export default {
        name: 'VkLogin',

        props: {
            link: {
                type: String,
                required: true
            },
            usage: {
                type: String,
                required: true
            }
        },

        computed: {
            buttonWidth() {
                return this.usage === 'login' ? 75 : 85;
            },

            buttonText() {
                return this.usage === 'login' ? this.$t('button.loginWith', '', { social: this.$t('common.vk') }) :  this.$t('button.registerWith', '', { social: this.$t('common.vk') });
            },

            buttonStyle() {
                return `width: ${this.buttonWidth}% !important;`;
            },

            iconStyle() {
                return `margin-left: ${this.usage === 'login' ? '-1.5rem' : '-2.5rem'}!important;`;
            },

            iconTextStyle() {
                return `margin-left: ${this.usage === 'login' ? '1rem' : '1.5rem'}!important;`;
            }
        }
    };
</script>

<style scoped>
    .vk-button {
        background-color: transparent !important;
        border: 1px solid #29ABE2 !important;
        border-radius: 5px !important;
        min-width: 200px;
    }

    .vk-button:hover {
        background-color: #29ABE2 !important;
    }

    .center-element {
        display: flex !important;
        flex-direction: row !important;
        justify-content: center !important;
        margin-left: auto !important;
        margin-right: auto !important;
    }

    .social-icon {
        left: 25%;
        position: absolute !important
    }
</style>